import type { BibleBookId } from "../../../lib/types/schema/bible/bibleManifestSchema";
import type { UseOpenApiQueryOptions } from "../../../request/hooks/openApi/useOpenApiQuery";
import { useOpenApiQuery } from "../../../request/hooks/openApi/useOpenApiQuery";
import { keyBibleBookSaves } from "./keyBibleSaves";

const urlBackendPath = "/me/bible/saves/{translationId}/{bookId}" as const;

type Props = Omit<
  UseOpenApiQueryOptions<typeof urlBackendPath>,
  "urlBackendPath"
> & { translationId: number; bookId: BibleBookId };

export const useRequestBibleBookSaves = ({
  translationId,
  bookId,
  ...props
}: Props) =>
  useOpenApiQuery({
    urlBackendPath,
    params: {
      path: { translationId, bookId },
    },
    queryKey: keyBibleBookSaves({ translationId, bookId }),
    ...props,
  });
